import { NormalCard } from "../Components/Cards"
import React, { Component } from 'react';
import axios from 'axios';
import { NormalButton } from "../Components/Buttons"
import ButtonGroup from 'react-bootstrap/ButtonGroup';

// import { CSSTransition } from "react-transition-group";

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            Name1: '',
            Name2: '',
            Name3: '',
            Location1: '',
            Location2: '',
            Location3: '',
            P1Comments1: '',
            P1Comments2: '',
            P1Comments3: '',
            P2Comments1: '',
            P2Comments2: '',
            P2Comments3: '',
            AvgRating1: '',
            AvgRating2: '',
            AvgRating3: '',
            isVisible: false
        }
        this.fadeOut = this.fadeOut.bind(this)
    }

    fadeOut() {
        setTimeout( () => {
            this.setState({isVisible : false});
        }, 2000)

        if (!this.state.isVisible) {
            return Promise.resolve("ok im done")

        }
    }
    fadeIn() {
        setTimeout( () => {
            this.setState({isVisible : true});
        }, 0)        
    }
    componentDidMount() {
        this.fadeIn();
        this.getRecentReviews();
    }

    
    getRecentReviews() {
        axios.get('/getRecentReviews')
            .then(response => response.data)
            .then(data => {
                if (data[0]) {
                    this.setState({
                        Name1: data[0].Name,
                        Name2: data[1].Name,
                        Name3: data[2].Name,
                        Location1: data[0].Location,
                        Location2: data[1].Location,
                        Location3: data[2].Location,
                        P1Comments1: data[0].P1Comments,
                        P1Comments2: data[1].P1Comments,
                        P1Comments3: data[2].P1Comments,
                        P2Comments1: data[0].P2Comments,
                        P2Comments2: data[1].P2Comments,
                        P2Comments3: data[2].P2Comments,
                        AvgRating1: Number(data[0].OverallRatingCalc).toFixed(1),
                        AvgRating2: Number(data[1].OverallRatingCalc).toFixed(1),
                        AvgRating3: Number(data[2].OverallRatingCalc).toFixed(1),
                    });

                }
            });

    }
    render () {
        return (
            <div>
                <div className="Home">
                    <div >
                        <h1 className="Home-Title">The Cafe Log</h1>
                    </div>

                    <div>
                        <p className="Home-Para">A compilation of every cafe visited, with expert analysis on each.</p>
                    </div>
                </div>
                <div className="Home-Options">
                    <ButtonGroup>
                        <NormalButton link="/addreview" text="Add new Review"></NormalButton>
                        <NormalButton link="/viewreview" text="View all reviews"></NormalButton>
                    </ButtonGroup>
                </div>
                <div className="Home-Under">
                    <div>
                        <p className="Home-Para2">Check out our most recent reviews below!</p>
                    </div>
                </div>

                <div className="NormalCard">
                    <NormalCard Title={this.state.Name1} Location={this.state.Location1} AvgRating={this.state.AvgRating1}/>
                </div>
                <div className="NormalCard">
                    <NormalCard Title={this.state.Name2} Location={this.state.Location2} AvgRating={this.state.AvgRating2}/>
                </div>
                <div className="NormalCard">
                    <NormalCard Title={this.state.Name3} Location={this.state.Location3} AvgRating={this.state.AvgRating3}/>
                </div>
                    
               

            </div>
        );
    };
};

export default Home;